// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"contextMenu_contextMenu__3NW5B","menuEntry":"contextMenu_menuEntry__y-c6m"};